import { Component } from '@angular/core';

@Component({
    selector: 'vp-error-403',
    templateUrl: './error-403.component.html',
    styleUrls: ['../errors.scss'],
    standalone: false
})
export class Error403Component {}
